var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ReusableLogicVersion_1;
/* eslint-disable import/no-duplicates */
import { Utils } from '@symon-ai/wisepipe-common';
import { DateConverter, JSON, JsonConverter, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { reusableLogicVersionSchemaValidation } from '../validations.generated';
export const REUSABLE_NAME_MAX_LENGTH = 100;
export const reusableLogicVersionSchema = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicVersion',
    type: 'object',
    properties: {
        versionID: { type: 'string', uid: 9 },
        versionName: { type: 'string', minLength: 1, maxLength: REUSABLE_NAME_MAX_LENGTH },
        createdAt: { type: 'string', format: 'date-time' },
        createdBy: { type: 'string', format: 'uuid' }
    },
    required: ['versionID', 'versionName', 'createdAt', 'createdBy']
};
let ReusableLogicVersion = ReusableLogicVersion_1 = class ReusableLogicVersion {
    constructor(versionID, versionName, createdAt, createdBy) {
        this.versionID = versionID;
        this.versionName = versionName;
        this.createdAt = createdAt;
        this.createdBy = createdBy;
        JSON.validate(this, ReusableLogicVersion_1);
    }
    static newID() {
        return Utils.newID(9);
    }
    static bufferID(versionID) {
        return Utils.base64StringToBuffer(versionID);
    }
    static getDefaultInitialName(name) {
        let truncatedName = name;
        if (name.length > ReusableLogicVersion_1.NAME_MAX_LENGTH - ReusableLogicVersion_1.INITIAL_VERSION_NAME.length - 1) {
            truncatedName = name
                .substring(0, ReusableLogicVersion_1.NAME_MAX_LENGTH - ReusableLogicVersion_1.INITIAL_VERSION_NAME.length - 2)
                .concat('…');
        }
        return `${truncatedName} ${ReusableLogicVersion_1.INITIAL_VERSION_NAME}`;
    }
};
ReusableLogicVersion.NAME_MAX_LENGTH = REUSABLE_NAME_MAX_LENGTH;
ReusableLogicVersion.INITIAL_VERSION_NAME = 'Initial Version';
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ReusableLogicVersion.prototype, "createdAt", void 0);
ReusableLogicVersion = ReusableLogicVersion_1 = __decorate([
    JsonSchemaV2(reusableLogicVersionSchema, reusableLogicVersionSchemaValidation)
], ReusableLogicVersion);
export { ReusableLogicVersion };
//# sourceMappingURL=reusableLogicVersion.js.map